module.exports = __webpack_public_path__ + "front-end-web-app.iqckO3uF.svg";